import React from 'react';

import {
  PaymentElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';

const StripeForm = () => {
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (event) => {
    event.preventDefault();

    const {error} = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `http://localhost:3000/confirmation/${localStorage.getItem("orderId")}`,
      },
    });

    if (error) {
      console.log(error);
      // handle error
    }
  }
  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <br />
      <button className='mainbutton'>Submit</button>
    </form>
  );
};

export default StripeForm;